var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-wrapper"},[_c('img',{staticClass:"image-with-fallback",attrs:{"src":_vm.currentSrc,"alt":_vm.alt},on:{"error":_vm.onError}}),_c('img',{staticClass:"image-zoomed",attrs:{"src":_vm.currentSrc,"alt":_vm.alt},on:{"error":_vm.onError}})])
}
var staticRenderFns = []

export { render, staticRenderFns }